import React, { useCallback, useContext, useMemo } from 'react'
import styled from 'styled-components'

import { inputStyles } from 'components/reusable/input/components/TextInput'
import Text from 'components/reusable/text'
import { colors } from 'helpers/colors'
import { modalEnum } from 'components/modals/v2/modal'
import { ModalContext } from 'contexts/contexts'
import DateHelpers from 'helpers/date_helpers'

/**
 * @todo missing implementation for desktop
 * @param onChange
 * @param value
 * @param placeholder
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function DatePicker({ onChange, value, placeholder, RightIcon, LeftIcon, className }) {
  const modalContext = useContext(ModalContext)

  const onClick = useCallback(() => {
    modalContext.onOpenModal(modalEnum.datePicker, { title: 'Shoot Date(s)', onChange, value })
  }, [onChange, value])

  const displayText = useMemo(() => {
    if (!value || value.length === 0) return ''
    const unixTimestamps = value.map((int) => DateHelpers.getTimeStampFromDayCode(int))
    return DateHelpers.timestampRangeLabel(unixTimestamps, true)
  }, [value])

  return (
    <Wrapper type="button" onClick={onClick} id="DatePicker" $RightIcon={RightIcon} $LeftIcon={LeftIcon} className={className}>
      {LeftIcon && (
        <LeftIconWrapper>
          <LeftIcon size={20} color={colors.primary[500]} />
        </LeftIconWrapper>
      )}
      {placeholder && (!value || value.length === 0) ? <AlignedText color={colors.gray[300]}>{placeholder}</AlignedText> : null}
      {value && value.length > 0 && <AlignedText color={colors.gray[700]}>{displayText}</AlignedText>}
      <RightSide Icon={RightIcon} value={value} />
    </Wrapper>
  )
}

// SvgCalendarOutline
function RightSide({ Icon, value }) {
  const daysCount = useMemo(() => {
    if (!value || value.length === 0) return 0
    return value.length
  }, [value])

  if (Icon)
    return (
      <IconWrapper>
        <Icon color={colors.light} size={20} />
      </IconWrapper>
    )

  if (!daysCount) return null
  return (
    <DaysBadge>
      {daysCount} {daysCount === 1 ? 'day' : 'days'}
    </DaysBadge>
  )
}

export const AlignedText = styled(Text)`
  line-height: 1.3;
`

const Wrapper = styled.button`
  ${inputStyles}
  padding-right: ${({ $RightIcon }) => ($RightIcon ? '48px' : '84px')} !important;
  ${({ $LeftIcon }) => $LeftIcon && 'padding-left: 54px'} !important;
  display: flex;
  position: relative;
  background-color: transparent;
  align-items: center;
  position: relative;
  cursor: pointer;
`

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  background-color: ${colors.gray[500]};
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
`

const LeftIconWrapper = styled.div`
  position: absolute;
  left: 22px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.3s;

  ${Wrapper}:hover & {
    transform: translateY(-50%) scale(1.1);
  }
`

const DaysBadge = styled.div`
  margin-left: auto;
  background-color: ${colors.primary[50]};
  color: ${colors.primary[500]};
  border: none;
  font-weight: 500;
  font-size: 11px;
  padding: 2px 10px;
  border-radius: 4px;
  right: 2em;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

export default DatePicker
